var isIdsEnabled = typeof process !== 'undefined' && (process === null || process === void 0 ? void 0 : process.env.WITH_TEST_ID) === 'true';
var getTestId = isIdsEnabled ? function (name) { return name; } : function () { return undefined; };
export { getTestId };
